import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './redux/store';

import { BrowserRouter as Router } from 'react-router-dom';
import { LangProvider } from './context/langProvider';

import AppRoutes from './AppRoutes';
import UseWebSocket from './components/UseWebSocket';
import { GoogleMapsProvider } from './context/GoogleMapsProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <LangProvider>
      <GoogleMapsProvider>
        <PersistGate loading={null} persistor={persistor}>
          <UseWebSocket>

            <Router>
              <AppRoutes />
            </Router>
          </UseWebSocket>
        </PersistGate>
      </GoogleMapsProvider>
    </LangProvider>
  </Provider>
);
